/**
 * Reserved OpenStack/Platform9 internal project names that must not appear in the tenant list.
 */
export const reservedTenantNames = ['admin', 'services', 'Default', 'heat']

/**
 * Returns true for real tenant projects, false for reserved internal projects.
 */
export const filterValidTenants = (tenant: { name?: string }): boolean =>
  !reservedTenantNames.includes(tenant.name ?? '')

/**
 * Return tenants with domain id
 */
export const filterOutDomains = (tenant: { domain_id?: string | null }): boolean =>
  !!tenant.domain_id
